import { ChunkedFileUploader } from '../Common/ChunkedFileUploader';

export default {
    init() {
        $(window).ready(function () {
            $.ajax({
                url: '/get-related-video',
                type: 'GET',
                data: {
                    url: window.location.pathname
                },
                success: function (response) {
                    let relatedVideo = response.related_video
                    if (relatedVideo && relatedVideo.length > 0) {
                        const target = window.location.pathname.replaceAll('/', '_');
                        let videoModalButton = $(
                            '<div data-toggle="modal" data-target="#video-modal_' + target + '" class="video_guides__input-label pl-3 py-2 align-items-center col-gap-12 cursor-pointer">' +
                            '<img style="width:28px;" class="open-modal" src="/images/video-button.png"/>' +
                            'Training Video'+
                            '</div>');
                        let videosHtml = '<div id="video-modal_' + target + '" class="modal fade standard-modal video-guide-user-modal" tabindex="-1" role="dialog" aria-label="Training videos" aria-hidden="true">' +
                                '<div class="modal-dialog modal-dialog-centered large-xl" role="document">' +
                                '<div class="modal-content p-0">' +
                                '<div class="modal-header"></div>' +
                                '<div class="modal-body p-0 video_guides__modal-video-content">'
                                // '<button type="button" class="video_guides__close" data-target="' + target + '" aria-label="Close">&times;</button>'
                                ;
                        let videoModal ='';
                        relatedVideo.forEach(element => {
                            videoModal +=
                                        `<div class="video_guides__modal-video-wrapper" data-video-id="${element.id}">`+
                                            `<div class="video_guides__modal-video-name">${escapeHtml(element.title)}`+
                                            `</div>`+
                                            `<div class="video_guides__modal-video-description">${escapeHtml(element.description || '')}`+
                                            `</div>`+
                                            '<video class="video_guides__video" id="video-guide_' + element.id + '" muted preload="metadata" controls>' +
                                                '<source src="' + element.local_path + '" type="video/mp4">' +
                                            '</video>' +
                                            buildTimestampLinks(element.id, element.video_timestamps || []) +
                                        '</div>';
                        });
                        videosHtml += videoModal;
                        videosHtml += '</div><div class="modal-footer"></div></div></div></div>';
                        $('body').find('.side-nav-container').append(videoModalButton)
                        $('body').append(videosHtml);
                        const userVideoModal = $(`#video-modal_${target}`);
                        initializeCustomVideoPlayers(userVideoModal.find('.video_guides__video'));
                        initializeVideoGuideReferenceModal(userVideoModal);
                        bindTimestampTracking($('.video_guides__video'));
                        userVideoModal.on('hide.bs.modal', function () {
                            stopVideos();
                        });
                    }
                },
                error: (response) =>{

                },
            })
        })

        $(".open-modal").click(function(event) {
            event.preventDefault()
            let target = $(this).data("target")
            if (!target) {
                return;
            }

            const modal = $("#video-modal_" + target);
            const state = modal.data('videoGuideReferenceState');
            const videoId = $(this).data('video-id');

            if (state && videoId !== undefined) {
                const index = state.items.findIndex(item => String($(item).data('video-id')) === String(videoId));
                activateReferenceVideo(state, index >= 0 ? index : 0, false);
            }

            if (modal.hasClass('modal')) {
                modal.modal('show');
            } else {
                modal.show();
            }
        });

        $(document).on('click', '.video_guides__close', function () {
            const target = $(this).data('target');
            const modal = $(`#video-modal_${target}`);
            if (modal.hasClass('modal')) {
                modal.modal('hide');
            } else {
                modal.hide();
            }
            stopVideos();
        });

        initializeCustomVideoPlayers($('.video_guides__video'));
        $('.video_guides__modal-video').each(function () {
            initializeVideoGuideReferenceModal($(this));
        });
        if ($('#video_preview').attr('src')) {
            initializeCustomVideoPlayers($('#video_preview'));
        }
        bindTimestampTracking($('.video_guides__video'));

        $(document).on('click', '.video-guide-timestamp-link', function () {
            const video = document.getElementById(`video-guide_${$(this).data('video-id')}`);
            const seconds = Number($(this).data('seconds'));

            seekVideo(video, seconds);
        });

        $('#video_file').on('input', function (event) {
            let file =  event.target.files[0];

            if (!file) {
                return;
            }

            let videoPreview = $('#video_preview')
            videoPreview.attr('src', URL.createObjectURL(file))
            videoPreview.attr('preload', 'metadata')
            videoPreview.show();
            videoPreview[0].load();
            initializeCustomVideoPlayers(videoPreview);
        })

        let timestampRowIndex = Date.now();

        $('.video-guide-timestamps-editor').each(function () {
            updateTimestampEmptyState($(this));
            validateTimestampEditor($(this));
        });

        $(document).on('click', '.video-guide-timestamp-add', function () {
            const editor = $(this).closest('.video-guide-timestamps-editor');
            const video = document.querySelector(editor.data('video-selector'));
            const errorWrapper = $('.modal-video-guides__body-wrapper-errors');

            if (!video || (!video.currentSrc && !video.getAttribute('src'))) {
                showVideoGuideErrors(errorWrapper, ['Select a video before adding timestamps.']);
                return;
            }

            hideVideoGuideErrors(errorWrapper);
            const seconds = Math.max(0, Math.floor(video.currentTime || 0));
            const row = createTimestampRow(timestampRowIndex++, seconds);

            editor.find('.video-guide-timestamps-editor__rows').append(row);
            sortTimestampRows(editor);
            updateTimestampEmptyState(editor);
            row.find('.video-guide-timestamp-label').focus();
            validateTimestampEditor(editor);
            refreshPlayerMarkers(document.querySelector(editor.data('video-selector')));
        });

        $(document).on('click', '.video-guide-timestamp-remove', function () {
            const editor = $(this).closest('.video-guide-timestamps-editor');

            $(this).closest('.video-guide-timestamp-row').remove();
            updateTimestampEmptyState(editor);
            validateTimestampEditor(editor);
            refreshPlayerMarkers(document.querySelector(editor.data('video-selector')));
        });

        $(document).on('input change', '.video-guide-timestamp-time', function () {
            const input = $(this);
            const row = input.closest('.video-guide-timestamp-row');
            const seconds = parseTimestamp(input.val());

            row.find('.video-guide-timestamp-seconds').val(seconds === null ? '' : seconds);
            validateTimestampEditor(input.closest('.video-guide-timestamps-editor'));
            refreshPlayerMarkers(document.querySelector(
                input.closest('.video-guide-timestamps-editor').data('video-selector')
            ));
        });

        $(document).on('input', '.video-guide-timestamp-label', function () {
            const editor = $(this).closest('.video-guide-timestamps-editor');
            refreshPlayerMarkers(document.querySelector(editor.data('video-selector')));
        });

        $(document).on('change', '.video-guide-timestamp-time', function () {
            const editor = $(this).closest('.video-guide-timestamps-editor');
            const video = document.querySelector(editor.data('video-selector'));
            const seconds = parseTimestamp($(this).val());

            if (seconds !== null) {
                sortTimestampRows(editor);
                seekVideo(video, seconds, false);
            }
        });

        $('#video_preview').on('loadedmetadata', function () {
            validateTimestampEditor($('.video-guide-timestamps-editor'));
            refreshPlayerMarkers(this);
        });

        $(window).click(function(event) {
            if ($(event.target).hasClass('video_guides__modal-video')) {
                $("#" + event.target.id).hide();
                stopVideos();
            }
        });

        $(".delete-video").click(function(event) {
            event.preventDefault()
            $.ajax({
                url: event.target.href,
                method: 'delete',
                success: () => {
                    window.location.reload()
                }
            })
        })

        $("#add_url_line").click(function() {
            $(this).before(
                '<input name="urls[]" type="text" class="modal-video-guides__body-wrapper-url" placeholder="URL for presenting the video">'
            )
        })

        $(".modal-video-guides__body-wrapper-url-edit-close").click(function () {
            $('#' + $(this).data('index')).remove()
            $(this).remove()
        })

        $("#save-video-guide-form").submit(function(e){
            e.preventDefault();
            const editor = $(this).find('.video-guide-timestamps-editor');
            const timestampsValid = validateTimestampEditor(editor);

            if (!this.reportValidity() || !timestampsValid) {
                return;
            }

            let button = $('#video-guide__submit_button')
            let spinner = $('#spinner')

            button.hide()
            spinner.show()

            let form = $(this)
            let fd = makeFormData(form)

            submitVideoGuideForm(form, fd, {
                spinner,
                button,
            });
        });

        $('#video-guide__chunked_submit_button').on('click', function (e) {
            e.preventDefault();

            const form = $('#save-video-guide-form')[0];
            const fileInput = $('#video_file')[0];
            const chunkedButton = $('#video-guide__chunked_submit_button');
            const chunkedSpinner = $('#chunked_spinner');
            const saveButton = $('#video-guide__submit_button');
            const progressWrapper = $('#chunked-upload-progress');
            const errorWrapper = $('.modal-video-guides__body-wrapper-errors');

            const timestampsValid = validateTimestampEditor($(form).find('.video-guide-timestamps-editor'));
            if (!form.reportValidity() || !timestampsValid) {
                return;
            }

            if (!fileInput.files.length) {
                showVideoGuideErrors(errorWrapper, ['There must be attached video']);
                return;
            }

            hideVideoGuideErrors(errorWrapper);
            chunkedButton.prop('disabled', true);
            saveButton.prop('disabled', true);
            chunkedSpinner.show();
            progressWrapper.removeClass('d-none').text('Uploading: 0%');

            const uploader = new ChunkedFileUploader({
                url: '/admin/chunked-upload',
                chunkSize: 2 * 1024 * 1024,
                extraData: {
                    directory: 'video_guides_managment',
                },
                onProgress: ({ percent }) => {
                    progressWrapper.text(`Uploading: ${percent}%`);
                },
            });

            uploader.upload(fileInput.files[0])
                .then((responses) => {
                    const response = responses[responses.length - 1];

                    if (!response || !response.completed || !response.path) {
                        throw new Error('Chunked upload was not completed.');
                    }

                    const localPath = `/storage/${response.path}`;
                    $('#chunked_video_path').val(localPath);

                    const $form = $('#save-video-guide-form');
                    const fd = makeChunkedFormData($form);

                    progressWrapper.text('Saving video guide...');

                    return submitVideoGuideForm($form, fd, {
                        spinner: chunkedSpinner,
                        button: chunkedButton,
                        saveButton,
                        progressWrapper,
                    });
                })
                .catch(() => {
                    resetChunkedUploadUi(chunkedButton, saveButton, chunkedSpinner, progressWrapper);
                    showVideoGuideErrors(errorWrapper, ['Chunked video upload failed. Please try again.']);
                });
        });

        function submitVideoGuideForm(form, fd, ui = {}) {
            const {
                spinner,
                button,
                saveButton,
                progressWrapper,
            } = ui;

            return $.ajax({
                url: form.attr('action'),
                method: form.attr('method'),
                data: fd,
                contentType: false,
                processData: false,
                success: function (response) {
                    window.location.href = response.href;
                },
                error: function (response) {
                    if (spinner) {
                        spinner.hide();
                    }
                    if (button) {
                        button.show().prop('disabled', false);
                    }
                    if (saveButton) {
                        saveButton.prop('disabled', false);
                    }
                    if (progressWrapper) {
                        progressWrapper.addClass('d-none').text('');
                    }

                    if (response.status == '422') {
                        const errorWrapper = $('.modal-video-guides__body-wrapper-errors');
                        const errors = [];

                        for (let errorKey in response.responseJSON.errors) {
                            const fieldErrors = response.responseJSON.errors[errorKey];
                            if (Array.isArray(fieldErrors)) {
                                errors.push(...fieldErrors);
                            } else {
                                errors.push(fieldErrors);
                            }
                        }

                        showVideoGuideErrors(errorWrapper, errors);
                    }
                }
            });
        }

        function makeChunkedFormData(form) {
            let fd = new FormData();

            form.serializeArray().forEach((field) => {
                fd.append(field.name, field.value);
            });

            return fd;
        }

        function showVideoGuideErrors(errorWrapper, errors) {
            errorWrapper.html('');
            errors.forEach((error) => {
                errorWrapper.append(`<div style="margin-bottom: 5px;">${error}</div>`);
            });
            errorWrapper.removeClass('d-none');
        }

        function hideVideoGuideErrors(errorWrapper) {
            errorWrapper.html('').addClass('d-none');
        }

        function resetChunkedUploadUi(chunkedButton, saveButton, chunkedSpinner, progressWrapper) {
            chunkedSpinner.hide();
            chunkedButton.show().prop('disabled', false);
            saveButton.prop('disabled', false);
            progressWrapper.addClass('d-none').text('');
        }

        function makeFormData(form) {
            let fileInput = $('.video_guides__file-input-label').find('#video_file')
            let fd = new FormData();

            form.serializeArray().map(field => {
                fd.append(field.name, field.value)
            })

            if (fileInput[0].files.length) {
                fd.append('video', fileInput[0].files[0])
            }

            return fd
        }

        function createTimestampRow(index, seconds) {
            const row = $('<div>', { class: 'video-guide-timestamp-row' });
            const secondsInput = $('<input>', {
                type: 'hidden',
                class: 'video-guide-timestamp-seconds',
                name: `timestamps[${index}][seconds]`,
                value: seconds,
            });
            const timeInput = $('<input>', {
                type: 'text',
                class: 'video-guide-timestamp-time',
                value: formatTimestamp(seconds),
                placeholder: 'MM:SS',
                'aria-label': 'Timestamp time',
                required: true,
            });
            const labelInput = $('<input>', {
                type: 'text',
                class: 'video-guide-timestamp-label',
                name: `timestamps[${index}][label]`,
                placeholder: 'Timestamp title',
                maxlength: 255,
                required: true,
            });
            const removeButton = $('<button>', {
                type: 'button',
                class: 'video-guide-timestamp-remove',
                'aria-label': 'Remove timestamp',
                html: '&times;',
            });

            return row.append(secondsInput, timeInput, labelInput, removeButton);
        }

        function parseTimestamp(value) {
            const parts = String(value).trim().split(':');

            if (parts.length < 2 || parts.length > 3 || parts.some(part => !/^\d+$/.test(part))) {
                return null;
            }

            const numbers = parts.map(Number);
            const seconds = numbers.pop();
            const minutes = numbers.pop();
            const hours = numbers.pop() || 0;

            if (seconds > 59 || (parts.length === 3 && minutes > 59)) {
                return null;
            }

            return (hours * 3600) + (minutes * 60) + seconds;
        }

        function formatTimestamp(seconds) {
            const totalSeconds = Math.max(0, Math.floor(Number(seconds) || 0));
            const hours = Math.floor(totalSeconds / 3600);
            const minutes = Math.floor((totalSeconds % 3600) / 60);
            const remainder = totalSeconds % 60;
            const time = `${String(minutes).padStart(2, '0')}:${String(remainder).padStart(2, '0')}`;

            return hours > 0 ? `${String(hours).padStart(2, '0')}:${time}` : time;
        }

        function validateTimestampEditor(editor) {
            if (!editor.length) {
                return true;
            }

            const video = document.querySelector(editor.data('video-selector'));
            const duration = video && Number.isFinite(video.duration) ? video.duration : null;
            const seenSeconds = new Set();
            let isValid = true;

            editor.find('.video-guide-timestamp-row').each(function () {
                const row = $(this);
                const timeInput = row.find('.video-guide-timestamp-time')[0];
                const seconds = parseTimestamp(timeInput.value);
                let message = '';

                if (seconds === null) {
                    message = 'Use MM:SS or HH:MM:SS.';
                } else if (duration !== null && seconds > duration) {
                    message = 'Timestamp cannot be longer than the video.';
                } else if (seenSeconds.has(seconds)) {
                    message = 'Timestamp times must be unique.';
                }

                timeInput.setCustomValidity(message);
                row.find('.video-guide-timestamp-seconds').val(seconds === null ? '' : seconds);

                if (message) {
                    isValid = false;
                } else {
                    seenSeconds.add(seconds);
                }
            });

            return isValid;
        }

        function updateTimestampEmptyState(editor) {
            editor.find('.video-guide-timestamps-editor__empty')
                .toggleClass('d-none', editor.find('.video-guide-timestamp-row').length > 0);
        }

        function sortTimestampRows(editor) {
            const rows = editor.find('.video-guide-timestamp-row').get();

            rows.sort((first, second) => {
                const firstSeconds = Number($(first).find('.video-guide-timestamp-seconds').val());
                const secondSeconds = Number($(second).find('.video-guide-timestamp-seconds').val());

                return firstSeconds - secondSeconds;
            });

            editor.find('.video-guide-timestamps-editor__rows').append(rows);
        }

        function stopVideos() {
            $(".video_guides__modal-video-content video").each(function() {
                if (this.paused === false) {
                    this.pause();
                    this.currentTime = 0;
                }
            });
        }

        $('.video_guides__file-input-label input[type=file]').on('change', function(){
            let file = this.files[0];

            if (file) {
                $(this).closest('.video_guides__file-input-label').find('.video_guides__file-input-text').html(file.name);
            }
        });

        function initializeVideoGuideReferenceModal(modal) {
            const content = modal.find('.video_guides__modal-video-content').first();
            const wrappers = content.children('.video_guides__modal-video-wrapper');

            if (!wrappers.length || modal.data('videoGuideReferenceState')) {
                return;
            }

            content.addClass('has-video-guide-reference');
            const target = content.children('.video_guides__close').first().data('target');
            const items = wrappers.detach().toArray();
            // const shell = $('<div>', { class: 'video-guide-reference' });
            const shell = content;
            const modalHeader = modal.find('div.modal-header');
            const modalFooter = modal.find('div.modal-footer');
            // const header = $('<div>', { class: 'video-guide-reference__header' });
            const headerTitle = $('<h2>', { class: 'video-guide-reference__header-title' });
            const headerActions = $('<div>', { class: 'video-guide-reference__header-actions' });
            const counter = $('<span>', {
                class: 'video-guide-reference__counter',
                'aria-live': 'polite',
            });
            const headerClose = $('<button>', {
                type: 'button',
                class: 'bb-close bb-close--s close',
                'data-target': target,
                'data-dismiss': 'modal',
                'aria-label': 'Close video tutorials',
                html: '&times;',
            });
            const body = $('<div>', { class: 'video-guide-reference__body' });
            const main = $('<div>', { class: 'video-guide-reference__main' });
            const primary = $('<div>', { class: 'video-guide-reference__primary' });
            const activeSlot = $('<div>', { class: 'video-guide-reference__active' });
            const timestampsPanel = $('<aside>', {
                class: 'video-guide-reference__timestamps',
                'aria-label': 'Video timestamps',
            });
            const timestampsTitle = $('<h3>', {
                class: 'video-guide-reference__timestamps-title',
                text: 'Timestamp',
            });
            const timestampsList = $('<div>', { class: 'video-guide-reference__timestamps-list' });
            const nextVideos = $('<section>', { class: 'video-guide-reference__next-videos' });
            const nextVideosTitle = $('<h3>', {
                class: 'video-guide-reference__next-title',
                text: 'Next Videos',
            });
            const thumbnails = $('<div>', {
                class: 'video-guide-reference__thumbnails',
                role: 'list',
                'aria-label': 'Video tutorials',
            });
            // const footer = $('<div>', { class: 'video-guide-reference__footer' });
            const footerClose = $('<button>', {
                type: 'button',
                class: 'video_guides__close video-guide-reference__footer-close',
                'data-target': target,
                text: 'Close',
            });
            const storage = $('<div>', {
                class: 'video-guide-reference__storage',
                hidden: true,
            });
            const state = {
                items,
                activeIndex: 0,
                activeSlot,
                storage,
                headerTitle,
                counter,
                timestampsList,
                thumbnails,
                videoData: [],
            };

            headerActions.append(counter, headerClose);
            modalHeader.append(headerTitle, headerActions);
            timestampsPanel.append(timestampsTitle, timestampsList);
            primary.append(activeSlot);
            main.append(primary, timestampsPanel);
            nextVideos.append(nextVideosTitle, thumbnails);
            modalFooter.append(footerClose);
            body.append(main, nextVideos);
            shell.append(body, storage);
            // content.empty().append(shell);
            modal.data('videoGuideReferenceState', state);

            items.forEach((item, index) => {
                const wrapper = $(item);
                const player = wrapper.find('.video-guide-player').first();
                const video = wrapper.find('video')[0];
                const title = wrapper.find('.video-guide-player__title').first().text().trim();
                const description = wrapper.find('.video-guide-player__description').first();
                const timestamps = getReferenceTimestamps(wrapper);
                const info = $('<div>', { class: 'video-guide-reference__info' });
                const infoHeader = $('<div>', { class: 'video-guide-reference__info-header' });
                const chapterTitle = $('<h3>', { class: 'video-guide-reference__chapter-title' });
                const nextButton = $('<button>', {
                    type: 'button',
                    class: 'video-guide-reference__next-button',
                    text: 'Next Tutorial',
                });
                const descriptionArea = $('<div>', { class: 'video-guide-reference__description-area' });
                const readMoreButton = $('<button>', {
                    type: 'button',
                    class: 'video-guide-reference__read-more',
                    text: 'Read more',
                });
                const thumbnail = $('<button>', {
                    type: 'button',
                    class: 'video-guide-reference__thumbnail',
                    role: 'listitem',
                    'aria-label': `Open video ${index + 1}: ${title}`,
                });
                const thumbnailVisual = $('<span>', {
                    class: 'video-guide-reference__thumbnail-visual',
                    html: playerIcon('play'),
                });
                const thumbnailTitle = $('<span>', {
                    class: 'video-guide-reference__thumbnail-title',
                    text: title,
                });

                wrapper
                    .attr('data-reference-index', index)
                    .removeClass('is-filmstrip-active is-filmstrip-inactive');

                infoHeader.append(chapterTitle, nextButton);
                descriptionArea.append(description, readMoreButton);
                info.append(infoHeader, descriptionArea);
                player.after(info);
                thumbnail.append(thumbnailVisual, thumbnailTitle);
                thumbnails.append(thumbnail);

                state.videoData.push({
                    title,
                    video,
                    wrapper,
                    timestamps,
                    chapterTitle,
                    nextButton,
                    readMoreButton,
                    thumbnail,
                });

                $(video)
                    .off('timeupdate.videoGuideReference ended.videoGuideReference')
                    .on('timeupdate.videoGuideReference', function () {
                        if (state.activeIndex === index) {
                            syncReferenceTimestamps(state);
                        }
                    })
                    .on('ended.videoGuideReference', function () {
                        if (state.activeIndex === index && index < state.items.length - 1) {
                            activateReferenceVideo(state, index + 1, true);
                        }
                    });

                nextButton.on('click', function () {
                    activateReferenceVideo(state, index + 1, true);
                });

                thumbnail.on('click', function () {
                    activateReferenceVideo(state, index, true);
                });

                readMoreButton.toggle(description.text().trim().length > 180);
                readMoreButton.on('click', function () {
                    const expanded = wrapper.toggleClass('is-description-expanded')
                        .hasClass('is-description-expanded');
                    $(this).text(expanded ? 'Show less' : 'Read more');
                });
            });

            activateReferenceVideo(state, 0, false);
        }

        function getReferenceTimestamps(wrapper) {
            return wrapper.find('.video-guide-timestamp-link').map(function () {
                const link = $(this);
                return {
                    seconds: Number(link.data('seconds')),
                    label: link.clone().children().remove().end().text().trim(),
                };
            }).get().sort((first, second) => first.seconds - second.seconds);
        }

        function activateReferenceVideo(state, index, shouldPlay) {
            if (index < 0 || index >= state.items.length) {
                return;
            }

            state.items.forEach((item, itemIndex) => {
                const wrapper = $(item);
                const video = wrapper.find('video')[0];
                const isActive = itemIndex === index;

                if (isActive) {
                    state.activeSlot.append(wrapper);
                } else {
                    if (video && !video.paused) {
                        video.pause();
                    }
                    state.storage.append(wrapper);
                }
            });

            state.activeIndex = index;
            const data = state.videoData[index];
            state.headerTitle.text(`Video: ${data.title}`);
            state.counter.text(`${index + 1} / ${state.items.length}`);
            data.nextButton.prop('disabled', index === state.items.length - 1);
            state.videoData.forEach((item, itemIndex) => {
                item.thumbnail
                    .toggleClass('is-active', itemIndex === index)
                    .attr('aria-current', itemIndex === index ? 'true' : null);
            });

            renderReferenceTimestamps(state);
            syncReferenceTimestamps(state);

            const activeVideo = $(state.items[index]).find('video')[0];
            if (shouldPlay && activeVideo) {
                if (activeVideo.ended) {
                    activeVideo.currentTime = 0;
                }
                const promise = activeVideo.play();
                if (promise) {
                    promise.catch(() => {});
                }
            }
        }

        function renderReferenceTimestamps(state) {
            const data = state.videoData[state.activeIndex];
            state.timestampsList.empty();

            if (!data.timestamps.length) {
                state.timestampsList.append(
                    $('<div>', {
                        class: 'video-guide-reference__timestamps-empty',
                        text: 'No timestamps',
                    })
                );
                return;
            }

            data.timestamps.forEach((timestamp, index) => {
                const button = $('<button>', {
                    type: 'button',
                    class: 'video-guide-reference__timestamp',
                    'data-timestamp-index': index,
                    'data-seconds': timestamp.seconds,
                    'aria-label': `Go to ${formatTimestamp(timestamp.seconds)}: ${timestamp.label}`,
                });
                const status = $('<span>', {
                    class: 'video-guide-reference__timestamp-status',
                    'aria-hidden': 'true',
                });
                const text = $('<span>', { class: 'video-guide-reference__timestamp-text' });
                text.append(
                    $('<span>', {
                        class: 'video-guide-reference__timestamp-time',
                        text: formatTimestamp(timestamp.seconds),
                    }),
                    $('<span>', {
                        class: 'video-guide-reference__timestamp-label',
                        text: timestamp.label,
                    })
                );
                button.append(status, text);
                button.on('click', function () {
                    seekVideo(data.video, timestamp.seconds);
                });
                state.timestampsList.append(button);
            });
        }

        function syncReferenceTimestamps(state) {
            const data = state.videoData[state.activeIndex];
            if (!data) {
                return;
            }

            if (!data.timestamps.length) {
                data.chapterTitle.text(data.title);
                return;
            }

            let currentIndex = 0;
            data.timestamps.forEach((timestamp, index) => {
                if (timestamp.seconds <= data.video.currentTime) {
                    currentIndex = index;
                }
            });

            data.chapterTitle.text(data.timestamps[currentIndex].label);
            state.timestampsList.find('.video-guide-reference__timestamp').each(function (index) {
                $(this)
                    .toggleClass('is-completed', index < currentIndex)
                    .toggleClass('is-current', index === currentIndex)
                    .toggleClass('is-upcoming', index > currentIndex);
            });
        }

        let fullscreenPlayer = null;

        function playerIcon(name) {
            const paths = {
                play: '<path class="video-guide-player__icon-fill" d="M8 5v14l11-7z"></path>',
                pause: '<path d="M9 5v14M15 5v14"></path>',
                volume: '<path d="M11 5 6.5 9H3v6h3.5l4.5 4V5ZM15 9c1.3 1.7 1.3 4.3 0 6M18 6c3 3.3 3 8.7 0 12"></path>',
                muted: '<path d="M11 5 6.5 9H3v6h3.5l4.5 4V5ZM16 10l5 5M21 10l-5 5"></path>',
                fullscreen: '<path d="M8 3H3v5M16 3h5v5M8 21H3v-5M16 21h5v-5"></path>',
                fullscreenExit: '<path d="M8 8H3V3M16 8h5V3M8 16H3v5M16 16h5v5"></path>',
            };

            return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
                paths[name] +
            '</svg>';
        }

        function initializeCustomVideoPlayers(videos) {
            videos.each(function () {
                const video = this;
                const videoElement = $(video);

                if (videoElement.closest('.video-guide-player').length) {
                    refreshPlayerMarkers(video);
                    updateCustomPlayer(video);
                    return;
                }

                videoElement.removeAttr('controls');
                videoElement.wrap('<div class="video-guide-player"></div>');

                const player = videoElement.closest('.video-guide-player');
                player.append(
                    '<button type="button" class="video-guide-player__center-play" aria-label="Play video">' +
                        playerIcon('play') +
                    '</button>' +
                    '<div class="video-guide-player__controls">' +
                        '<button type="button" class="video-guide-player__play" aria-label="Play video">' +
                            playerIcon('play') +
                        '</button>' +
                        '<span class="video-guide-player__current-time">00:00</span>' +
                        '<div class="video-guide-player__progress" role="slider" tabindex="0" ' +
                            'aria-label="Video progress" aria-valuemin="0" aria-valuemax="0" aria-valuenow="0">' +
                            '<div class="video-guide-player__buffered"></div>' +
                            '<div class="video-guide-player__played"></div>' +
                            '<div class="video-guide-player__markers"></div>' +
                        '</div>' +
                        '<span class="video-guide-player__duration">00:00</span>' +
                        '<button type="button" class="video-guide-player__mute" aria-label="Mute video">' +
                            playerIcon('volume') +
                        '</button>' +
                        '<input class="video-guide-player__volume" type="range" min="0" max="1" step="0.05" ' +
                            'aria-label="Video volume">' +
                        '<button type="button" class="video-guide-player__fullscreen" ' +
                            'aria-label="Open fullscreen">' +
                            playerIcon('fullscreen') +
                        '</button>' +
                    '</div>' +
                    '<div class="video-guide-player__tooltip" role="tooltip"></div>'
                );

                const contentWrapper = player.closest('.video_guides__modal-video-wrapper');
                const title = contentWrapper.children('.video_guides__modal-video-name').first();
                const description = contentWrapper.children('.video_guides__modal-video-description').first();

                if (title.length) {
                    title.addClass('video-guide-player__title').prependTo(player);
                }

                if (description.length) {
                    description.addClass('video-guide-player__description').insertAfter(player);
                }

                const playButton = player.find('.video-guide-player__play');
                const muteButton = player.find('.video-guide-player__mute');
                const volumeInput = player.find('.video-guide-player__volume');
                const progress = player.find('.video-guide-player__progress');

                video.volume = 0.5;
                video.muted = false;
                volumeInput.val(video.muted ? 0 : video.volume);

                playButton.on('click', function () {
                    toggleVideoPlayback(video);
                });

                player.find('.video-guide-player__center-play').on('click', function () {
                    toggleVideoPlayback(video);
                });

                videoElement.on('click.videoGuidePlayer', function () {
                    toggleVideoPlayback(video);
                });

                videoElement.on('dblclick.videoGuidePlayer', function () {
                    toggleVideoFullscreen(player[0]);
                });

                videoElement.on(
                    'loadedmetadata.videoGuidePlayer durationchange.videoGuidePlayer progress.videoGuidePlayer',
                    function () {
                        updateCustomPlayer(video);
                        refreshPlayerMarkers(video);
                    }
                );

                videoElement.on(
                    'timeupdate.videoGuidePlayer play.videoGuidePlayer pause.videoGuidePlayer ' +
                    'ended.videoGuidePlayer volumechange.videoGuidePlayer',
                    function (event) {
                        updateCustomPlayer(video);

                        if (event.type === 'play') {
                            scheduleControlsHide(player, video);
                        } else if (event.type === 'pause' || event.type === 'ended') {
                            showPlayerControls(player, video, false);
                        }
                    }
                );

                progress.on('click', function (event) {
                    if ($(event.target).hasClass('video-guide-player__marker')) {
                        return;
                    }

                    seekVideo(video, getProgressSeconds(video, this, event.clientX));
                });

                progress.on('keydown', function (event) {
                    let seconds = video.currentTime;

                    if (event.key === 'ArrowLeft') {
                        seconds -= 5;
                    } else if (event.key === 'ArrowRight') {
                        seconds += 5;
                    } else if (event.key === 'Home') {
                        seconds = 0;
                    } else if (event.key === 'End') {
                        seconds = video.duration;
                    } else {
                        return;
                    }

                    event.preventDefault();
                    seekVideo(video, Math.min(Math.max(seconds, 0), video.duration || 0), false);
                });

                muteButton.on('click', function () {
                    const isSilent = video.muted || video.volume === 0;

                    if (isSilent) {
                        if (video.volume === 0) {
                            video.volume = 0.5;
                        }
                        video.muted = false;
                    } else {
                        video.muted = true;
                    }
                });

                volumeInput.on('input', function () {
                    video.volume = Number(this.value);
                    video.muted = video.volume === 0;
                });

                player.find('.video-guide-player__fullscreen').on('click', function () {
                    toggleVideoFullscreen(player[0]);
                });

                player.on('mousemove.videoGuidePlayer touchstart.videoGuidePlayer', function () {
                    showPlayerControls(player, video);
                });

                player.on('mouseleave.videoGuidePlayer', function () {
                    scheduleControlsHide(player, video, 500);
                });

                player.on('focusin.videoGuidePlayer', function () {
                    showPlayerControls(player, video, false);
                });

                player.on('focusout.videoGuidePlayer', function () {
                    scheduleControlsHide(player, video);
                });

                if (video.readyState >= 1) {
                    updateCustomPlayer(video);
                    refreshPlayerMarkers(video);
                }
            });

            $(document)
                .off(
                    'fullscreenchange.videoGuidePlayer webkitfullscreenchange.videoGuidePlayer ' +
                    'fullscreenerror.videoGuidePlayer webkitfullscreenerror.videoGuidePlayer'
                )
                .on(
                    'fullscreenchange.videoGuidePlayer webkitfullscreenchange.videoGuidePlayer ' +
                    'fullscreenerror.videoGuidePlayer webkitfullscreenerror.videoGuidePlayer',
                    function () {
                        updateFullscreenButtons();
                    }
                );
        }

        function toggleVideoPlayback(video) {
            if (video.paused || video.ended) {
                const promise = video.play();
                if (promise) {
                    promise.catch(() => {});
                }
            } else {
                video.pause();
            }
        }

        function updateCustomPlayer(video) {
            const player = $(video).closest('.video-guide-player');
            if (!player.length) {
                return;
            }

            const duration = Number.isFinite(video.duration) ? video.duration : 0;
            const currentTime = Number.isFinite(video.currentTime) ? video.currentTime : 0;
            const progress = duration > 0 ? (currentTime / duration) * 100 : 0;
            const playButton = player.find('.video-guide-player__play');
            const muteButton = player.find('.video-guide-player__mute');
            const isSilent = video.muted || video.volume === 0;

            player
                .toggleClass('is-paused', video.paused)
                .toggleClass('is-playing', !video.paused);

            player.find('.video-guide-player__played').css('width', `${progress}%`);
            player.find('.video-guide-player__buffered').css('width', `${getBufferedPercent(video)}%`);
            player.find('.video-guide-player__current-time').text(formatTimestamp(currentTime));
            player.find('.video-guide-player__duration').text(formatTimestamp(duration));
            player.find('.video-guide-player__progress')
                .attr('aria-valuemax', Math.floor(duration))
                .attr('aria-valuenow', Math.floor(currentTime))
                .attr('aria-valuetext', `${formatTimestamp(currentTime)} of ${formatTimestamp(duration)}`);

            let activeMarker = null;
            const markers = player.find('.video-guide-player__marker');
            markers.each(function () {
                if (Number($(this).data('seconds')) <= currentTime) {
                    activeMarker = this;
                }
            });
            markers.removeClass('is-active');
            if (activeMarker) {
                $(activeMarker).addClass('is-active');
            }

            setPlayerButtonIcon(
                playButton,
                video.paused ? 'play' : 'pause',
                video.paused ? 'Play video' : 'Pause video'
            );

            setPlayerButtonIcon(
                muteButton,
                isSilent ? 'muted' : 'volume',
                isSilent ? 'Unmute video' : 'Mute video'
            );

            player.find('.video-guide-player__volume').val(video.muted ? 0 : video.volume);
        }

        function setPlayerButtonIcon(button, icon, label) {
            if (button.data('icon') !== icon) {
                button.html(playerIcon(icon)).data('icon', icon);
            }

            button.attr('aria-label', label);
        }

        function getBufferedPercent(video) {
            if (!video.duration || !video.buffered.length) {
                return 0;
            }

            return Math.min((video.buffered.end(video.buffered.length - 1) / video.duration) * 100, 100);
        }

        function showPlayerControls(player, video, scheduleHide = true) {
            clearTimeout(player.data('controlsTimer'));
            player.removeClass('is-controls-hidden');

            if (scheduleHide && !video.paused) {
                scheduleControlsHide(player, video);
            }
        }

        function scheduleControlsHide(player, video, delay = 2500) {
            clearTimeout(player.data('controlsTimer'));

            if (video.paused) {
                return;
            }

            const timer = setTimeout(() => {
                if (!player[0].contains(document.activeElement)) {
                    player.addClass('is-controls-hidden');
                }
            }, delay);

            player.data('controlsTimer', timer);
        }

        function getProgressSeconds(video, progress, clientX) {
            const bounds = progress.getBoundingClientRect();
            const ratio = Math.min(Math.max((clientX - bounds.left) / bounds.width, 0), 1);

            return ratio * (video.duration || 0);
        }

        function refreshPlayerMarkers(video) {
            if (!video) {
                return;
            }

            const player = $(video).closest('.video-guide-player');
            const markersContainer = player.find('.video-guide-player__markers');
            const duration = Number.isFinite(video.duration) ? video.duration : 0;

            if (!markersContainer.length || duration <= 0) {
                return;
            }

            const timestamps = getPlayerTimestamps(video, player);
            markersContainer.empty();

            timestamps.forEach((timestamp) => {
                if (timestamp.seconds < 0 || timestamp.seconds > duration) {
                    return;
                }

                const marker = $('<button>', {
                    type: 'button',
                    class: 'video-guide-player__marker',
                    'data-tooltip': `${formatTimestamp(timestamp.seconds)} — ${timestamp.label}`,
                    'aria-label': `Go to ${formatTimestamp(timestamp.seconds)}: ${timestamp.label}`,
                    'data-seconds': timestamp.seconds,
                    'data-position': (timestamp.seconds / duration) * 100,
                }).css('left', `${(timestamp.seconds / duration) * 100}%`);

                marker.on('click', function (event) {
                    event.stopPropagation();
                    seekVideo(video, timestamp.seconds);
                });

                marker.on('mouseenter focus', function () {
                    showPlayerControls(player, video, false);
                    showMarkerTooltip(player, $(this));
                });

                marker.on('mouseleave blur', function () {
                    hideMarkerTooltip(player);
                    scheduleControlsHide(player, video);
                });

                markersContainer.append(marker);
            });
        }

        function showMarkerTooltip(player, marker) {
            const tooltip = player.find('.video-guide-player__tooltip');
            const playerWidth = player.innerWidth();
            const markerLeft = (Number(marker.data('position')) / 100) * playerWidth;

            tooltip.text(marker.data('tooltip')).addClass('is-visible');

            const halfWidth = tooltip.outerWidth() / 2;
            const clampedLeft = Math.min(
                Math.max(markerLeft, halfWidth + 8),
                playerWidth - halfWidth - 8
            );

            tooltip.css('left', `${clampedLeft}px`);
        }

        function hideMarkerTooltip(player) {
            player.find('.video-guide-player__tooltip').removeClass('is-visible');
        }

        function getPlayerTimestamps(video, player) {
            if (video.id === 'video_preview') {
                return $('.video-guide-timestamps-editor .video-guide-timestamp-row').map(function () {
                    const row = $(this);
                    return {
                        seconds: parseTimestamp(row.find('.video-guide-timestamp-time').val()),
                        label: row.find('.video-guide-timestamp-label').val() || '',
                    };
                }).get().filter(timestamp => timestamp.seconds !== null);
            }

            return player.nextAll('.video-guide-timestamps').first()
                .find('.video-guide-timestamp-link')
                .map(function () {
                    const link = $(this);
                    return {
                        seconds: Number(link.data('seconds')),
                        label: link.clone().children().remove().end().text().trim(),
                    };
                }).get();
        }

        function toggleVideoFullscreen(player) {
            const fullscreenElement = document.fullscreenElement || document.webkitFullscreenElement;

            if (fullscreenElement) {
                if (document.exitFullscreen) {
                    const promise = document.exitFullscreen();
                    if (promise) {
                        promise.catch(() => updateFullscreenButtons());
                    }
                } else if (document.webkitExitFullscreen) {
                    document.webkitExitFullscreen();
                }
                return;
            }

            fullscreenPlayer = player;
            const fullscreenTarget = document.documentElement;

            if (fullscreenTarget.requestFullscreen) {
                const promise = fullscreenTarget.requestFullscreen({
                    navigationUI: 'hide',
                });
                if (promise) {
                    promise.catch(() => {
                        fullscreenPlayer = null;
                        updateFullscreenButtons();
                    });
                }
            } else if (fullscreenTarget.webkitRequestFullscreen) {
                fullscreenTarget.webkitRequestFullscreen();
            } else {
                fullscreenPlayer = null;
            }
        }

        function updateFullscreenButtons() {
            const fullscreenElement = document.fullscreenElement || document.webkitFullscreenElement;
            const activePlayer = fullscreenElement ? fullscreenPlayer : null;

            $('.video-guide-player').each(function () {
                const isFullscreen = activePlayer === this;
                $(this).toggleClass('is-fullscreen', isFullscreen);
                setPlayerButtonIcon(
                    $(this).find('.video-guide-player__fullscreen'),
                    isFullscreen ? 'fullscreenExit' : 'fullscreen',
                    isFullscreen ? 'Exit fullscreen' : 'Open fullscreen'
                );
            });

            $('body').toggleClass('video-guide-fullscreen-active', Boolean(activePlayer));

            if (!fullscreenElement) {
                fullscreenPlayer = null;
            }
        }

        function buildTimestampLinks(videoId, timestamps) {
            if (!timestamps.length) {
                return '';
            }

            const links = timestamps.map(timestamp => (
                `<button type="button" class="video-guide-timestamp-link" data-video-id="${videoId}" data-seconds="${timestamp.seconds}">` +
                    `<span>${formatTimestamp(timestamp.seconds)}</span>${escapeHtml(timestamp.label)}` +
                '</button>'
            )).join('');

            return `<div class="video-guide-timestamps" hidden>${links}</div>`;
        }

        function bindTimestampTracking(videos) {
            videos.off('timeupdate.videoGuideTimestamps').on('timeupdate.videoGuideTimestamps', function () {
                const links = $(`.video-guide-timestamp-link[data-video-id="${this.id.replace('video-guide_', '')}"]`);
                const currentTime = this.currentTime;
                let activeLink = null;

                links.each(function () {
                    if (Number($(this).data('seconds')) <= currentTime) {
                        activeLink = this;
                    }
                });

                links.removeClass('is-active');
                if (activeLink) {
                    $(activeLink).addClass('is-active');
                }
            });
        }

        function seekVideo(video, seconds, play = true) {
            if (!video || !Number.isFinite(seconds)) {
                return;
            }

            const seek = () => {
                video.currentTime = seconds;
                if (play) {
                    const promise = video.play();
                    if (promise) {
                        promise.catch(() => {});
                    }
                }
            };

            if (video.readyState >= 1) {
                seek();
            } else {
                $(video).one('loadedmetadata', seek);
                video.load();
            }
        }

        function escapeHtml(value) {
            return $('<div>').text(String(value)).html();
        }
    },
}
